export interface ISheetRow {
    cells: (string | null)[];
}
